import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { BackendAsAServiceClient } from './backend-as-a-service-client.js';

export function useBackendAsAServiceClient(): BackendAsAServiceClient {
  const httpClient = useHttpClient({ type: 'backoffice' });
  return useMemo(() => new BackendAsAServiceClient(httpClient), [httpClient]);
}
